import { 
    FETCH_APPOINTMENTS_REQUEST,
    FETCH_APPOINTMENTS_SUCCESS, 
    FETCH_APPOINTMENTS_FAILURE, 
    RESET_UPCOMING_APPOINTMENTS
} from '../actions/appointmentTypes'; 

const initialState = {
    appointments: [],
    appointmentloading: false,
    error: null,
};

const appointmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPOINTMENTS_REQUEST:
            return { ...state, appointmentloading: true, error: null };
        case FETCH_APPOINTMENTS_SUCCESS:
            return { ...state, appointmentloading: false, appointments: action.payload, error: null };
        case FETCH_APPOINTMENTS_FAILURE:
            return { ...state, appointmentloading: false, error: action.payload };

        case RESET_UPCOMING_APPOINTMENTS : 
            return initialState;

        
        default:
            return state;
    }
};

export default appointmentReducer;
